module.exports = __webpack_public_path__ + "media/SketchScope_Asset.0e3918b2.mp4";